import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../layout/Layout';
import { submitInternshipForm } from '../lib/api';

export default function Internship() {
  const [form, setForm] = useState({ name: '', college: '', dob: '', degree: '', gender: '', year: '', email: '', phone: '', address: '', message: '' });
  const [status, setStatus] = useState(null);
  const [errorMsg, setErrorMsg] = useState('');

  function handleChange(e) {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus('sending');
    setErrorMsg('');
    try {
      await submitInternshipForm(form);
      setStatus('success');
      setForm({ name: '', college: '', dob: '', degree: '', gender: '', year: '', email: '', phone: '', address: '', message: '' });
    } catch (err) {
      setStatus('error');
      setErrorMsg(err.message || 'Something went wrong. Please try again.');
    }
  }

  const inputClass = "w-full px-4 py-3 border border-gray-200 rounded-lg text-brand-dark placeholder-gray-400 focus:outline-none focus:border-brand focus:ring-1 focus:ring-brand transition-colors bg-white text-sm";

  return (
    <Layout>
      {/* Page Header */}
      <section className="relative overflow-hidden min-h-[280px] md:min-h-[360px] flex items-center bg-brand-dark">
        <video className="absolute inset-0 h-full w-full object-cover opacity-40" autoPlay muted loop playsInline>
          <source src="/internship.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-gradient-to-r from-brand-dark/30 to-brand/5"></div>
        <div className="container relative z-10 py-20">
          <div className="text-center">
            <h2 className="text-4xl md:text-5xl font-bold font-heading text-white mb-4">Internship</h2>
            <ul className="flex justify-center items-center gap-3 text-white/70 text-sm list-none p-0 m-0">
              <li><Link className="hover:text-brand transition-colors" to="/career">Career</Link></li>
              <li><span className="text-white/40">/</span></li>
              <li className="text-brand">Internship</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Application Form */}
      <section className="py-16 bg-white">
        <div className="container">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-brand-dark mb-3">
              We are Delighted that you are interested in joining our internship program!
            </h2>
            <p className="text-gray-500 text-sm">Please fill out the following form to register.</p>
          </div>

          <div className="max-w-3xl mx-auto">
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <div className="absolute inset-0 bg-cover bg-center opacity-5" style={{ backgroundImage: 'url(/assets/images/pattern/contact-page-pattern.jpg)' }}></div>
              <div className="relative z-10 bg-brand-dark/95 p-8 md:p-12 rounded-2xl">
                {status === 'success' && (
                  <div className="mb-6 px-4 py-3 bg-green-500/20 border border-green-500/30 text-green-300 rounded-lg text-sm">
                    Your application has been submitted successfully!
                  </div>
                )}
                {status === 'error' && (
                  <div className="mb-6 px-4 py-3 bg-red-500/20 border border-red-500/30 text-red-300 rounded-lg text-sm">
                    {errorMsg}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="row">
                    {[
                      { type: 'text', name: 'name', placeholder: 'Full Name' },
                      { type: 'text', name: 'college', placeholder: 'University/College' },
                      { type: 'text', name: 'dob', placeholder: 'Date of Birth' },
                      { type: 'text', name: 'degree', placeholder: 'Degree Program' },
                      { type: 'text', name: 'gender', placeholder: 'Gender' },
                      { type: 'text', name: 'year', placeholder: 'Year of Study' },
                      { type: 'email', name: 'email', placeholder: 'Email Address' },
                      { type: 'text', name: 'phone', placeholder: 'Phone' },
                      { type: 'text', name: 'address', placeholder: 'Address' },
                    ].map(({ type, name, placeholder }) => (
                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12" key={name}>
                        <div className="mb-4">
                          <input
                            type={type}
                            placeholder={placeholder}
                            name={name}
                            value={form[name]}
                            onChange={handleChange}
                            required
                            className={inputClass}
                          />
                        </div>
                      </div>
                    ))}

                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                      <div className="mb-6">
                        <textarea
                          name="message"
                          placeholder="Your Message here"
                          value={form.message}
                          onChange={handleChange}
                          required
                          rows={5}
                          className={inputClass + ' resize-none'}
                        ></textarea>
                      </div>
                      <div className="text-center">
                        <button
                          type="submit"
                          disabled={status === 'sending'}
                          className="inline-flex items-center gap-2 bg-brand text-white font-semibold px-8 py-3 rounded-full hover:bg-white hover:text-brand-dark transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
                        >
                          {status === 'sending' ? 'Submitting…' : 'Apply Now'}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Google Map */}
      <section className="w-full">
        <iframe
          src="https://maps.google.com/maps?q=44+Abelard+Ave,+Brampton,+ON+L6Y2K8,+Canada&t=&z=15&ie=UTF8&iwloc=&output=embed"
          className="w-full h-72 md:h-96 border-0 block"
          allowFullScreen=""
          title="Office map"
        ></iframe>
      </section>

      {/* Contact Info */}
      <section className="py-16 bg-gray-50">
        <div className="container">
          <div className="relative bg-white rounded-2xl shadow-xl overflow-hidden p-8 md:p-12">
            <div className="absolute inset-0 opacity-5" style={{ backgroundImage: 'url(/assets/images/shapes/contact-info-v1-bg0.png)', backgroundSize: 'cover' }}></div>
            <div className="row relative z-10">
              {[
                { iconClass: 'icon-location-filled', label: 'Address', lines: ['44 Abelard Ave, Brampton, ON L6Y2K8, Canada.'] },
                { iconClass: 'icon-phone-auricular', label: 'Get In Touch', lines: ['+1(647)-687-4226'], hrefs: ['tel:+16476874226'] },
                { iconClass: 'icon-email2', label: 'Quick Email us', lines: ['magizhinitech@gmail.com'], hrefs: ['mailto:magizhinitech@gmail.com'] },
              ].map(({ iconClass, label, lines, hrefs }, i) => (
                <div className="col-xl-4 col-lg-4" key={i}>
                  <div className="flex items-start gap-4 mb-8 xl:mb-0">
                    <div className="flex-shrink-0 w-14 h-14 rounded-full bg-brand flex items-center justify-center text-white text-xl">
                      <span className={iconClass}></span>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500 uppercase tracking-widest font-medium mb-1">{label}</p>
                      {lines.map((line, j) => (
                        hrefs ? (
                          <h3 key={j} className="text-brand-dark font-semibold text-sm leading-relaxed">
                            <a href={hrefs[j]} className="hover:text-brand transition-colors">{line}</a>
                          </h3>
                        ) : (
                          <h3 key={j} className="text-brand-dark font-semibold text-sm leading-relaxed">{line}</h3>
                        )
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}

